import { createApp } from 'vue'
import DonationCard from './DonationCard'

const el = '.kb-component--donation-card'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((DonationCardDOM) => {
            const component = createApp(DonationCard).use(Store)
            component.mount(DonationCardDOM)
        })
    }
}
